import { Anchor, Plus, Trash2 } from 'lucide-react';
import { Section, Field, EditButton, EditActions } from '../ui';
import { ic } from '../helpers';
import { RECREATIONAL_TYPES } from '../constants';

// ─────────────────────────────────────────
// RECREATIONAL UNITS SECTION
// Boats, motorcycles, ATVs, golf carts, RVs, jet skis.
// ─────────────────────────────────────────
export default function RecreationalSection({
  recreationalUnits,
  editingRecId,
  recDraft,
  setRecDraft,
  saving,
  onAddRecUnit,
  onStartEditRecUnit,
  onSaveRecUnit,
  onCancelEditRecUnit,
  onDeleteRecUnit,
}) {
  return (
    <Section
      title={`Recreational Units (${recreationalUnits.length})`}
      icon={Anchor}
      action={
        <button
          onClick={onAddRecUnit}
          className="flex items-center gap-1 px-3 py-1 rounded-lg bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700 transition"
        >
          <Plus size={11} /> Add Unit
        </button>
      }
    >
      <div className="space-y-3 pt-3">
        {recreationalUnits.length === 0 && (
          <p className="text-sm text-slate-400 text-center py-4">No recreational units added yet.</p>
        )}

        {recreationalUnits.map((unit) => {
          const isEditing = editingRecId === unit.id;
          const draft = isEditing ? recDraft : unit;
          const update = (key, val) => setRecDraft(p => ({ ...p, [key]: val }));

          return (
            <div key={unit.id} className="border border-slate-200 rounded-xl overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 bg-slate-50 border-b">
                <div className="flex items-center gap-2">
                  <Anchor size={14} className="text-blue-600" />
                  <span className="text-sm font-semibold text-slate-700">
                    {[unit.year, unit.unitType, unit.make, unit.model].filter(Boolean).join(' ') || 'New Unit'}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  {isEditing
                    ? <EditActions onSave={() => onSaveRecUnit(unit.id)} onCancel={onCancelEditRecUnit} saving={saving} />
                    : <>
                      <EditButton onClick={() => onStartEditRecUnit(unit)} />
                      <button onClick={() => onDeleteRecUnit(unit.id)} className="p-1 text-slate-400 hover:text-red-500 transition">
                        <Trash2 size={13} />
                      </button>
                    </>
                  }
                </div>
              </div>
              <div className="p-4 grid grid-cols-3 gap-3">
                {isEditing ? (
                  <>
                    <div>
                      <label className="block text-xs font-medium text-slate-500 mb-1">Type</label>
                      <select value={draft.unitType || ''} onChange={e => update('unitType', e.target.value)} className={ic}>
                        {RECREATIONAL_TYPES.map(t => <option key={t}>{t}</option>)}
                      </select>
                    </div>
                    {['year', 'make', 'model'].map(key => (
                      <div key={key}>
                        <label className="block text-xs font-medium text-slate-500 mb-1 capitalize">{key}</label>
                        <input
                          type={key === 'year' ? 'number' : 'text'}
                          value={draft[key] || ''}
                          onChange={e => update(key, e.target.value)}
                          className={ic}
                        />
                      </div>
                    ))}
                    <div>
                      <label className="block text-xs font-medium text-slate-500 mb-1">Title Holder</label>
                      <input value={draft.titleHolder || ''} onChange={e => update('titleHolder', e.target.value)} className={ic} />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-slate-500 mb-1">Primary Operator</label>
                      <input value={draft.primaryDriver || ''} onChange={e => update('primaryDriver', e.target.value)} className={ic} />
                    </div>
                  </>
                ) : (
                  <>
                    <Field label="Type" value={unit.unitType} editing={false} />
                    <Field label="Year" value={unit.year} editing={false} />
                    <Field label="Make" value={unit.make} editing={false} />
                    <Field label="Model" value={unit.model} editing={false} />
                    <Field label="Title Holder" value={unit.titleHolder} editing={false} />
                    <Field label="Primary Operator" value={unit.primaryDriver} editing={false} />
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}